// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"691":"49fe17fd28e1f6ea7fb9","883":"b239a2299ff5baa0cd39"}[chunkId] + ".js";
};